import { ReactNode } from 'react';
import { Box } from '@mui/material';
import Navbar from './Layout/Navbar';
import { useTheme } from '../contexts/ThemeContext';

const Layout = ({ children }: { children: ReactNode }) => {
  const { themePreferences } = useTheme();
  
  console.log('Layout rendering with Navbar');
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          mt: themePreferences.showGovernmentBanner ? '118px' : '90px', // Account for navbar height
          width: '100%'
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
